import { useState, useContext, useMemo, useEffect, useCallback } from 'react';
// @ts-expect-error untyped module atom
import { deref, unwatch, watch, makeAtom } from 'atom';
// @ts-expect-error untyped module reference-resolvers
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module reference-resolvers
import { isResolved, isError, isLoading } from 'reference-resolvers/utils';
// @ts-expect-error untyped module reference-resolvers
import ReferenceResolversContext from 'reference-resolvers/ReferenceResolversContext';
import { isDefaultEmptyPropertyValue } from 'automation-ui-references/object-type-properties/PropertyValueDefaults';

// only accurate for resolvers[ReferenceObjectTypes.OBJECT_PROPERTIES]

const EMPTY_RESULT = {
  loading: false,
  data: undefined,
  error: undefined
};
export function usePropertyResolver(objectTypeId, propertyName) {
  const [result, setResult] = useState(EMPTY_RESULT);
  const resolvers = useContext(ReferenceResolversContext);
  const {
    resolverFactory,
    resolversCache
  } = resolvers[ReferenceObjectTypes.OBJECT_PROPERTIES]();
  const resolver = useMemo(() => objectTypeId && resolverFactory(objectTypeId)(resolversCache), [objectTypeId, resolverFactory, resolversCache]);
  const handleAtomChange = useCallback(value => {
    // this function gets called during the rendering lifecycle, so we use promise resolve to break out
    Promise.resolve().then(() => {
      if (isLoading(value)) {
        setResult({
          loading: true,
          data: undefined,
          error: undefined
        });
      } else if (isResolved(value)) {
        setResult({
          loading: false,
          data: value.referencedObject && value.toJS().referencedObject,
          error: undefined
        });
      } else if (isError(value)) {
        setResult({
          loading: false,
          data: undefined,
          error: value
        });
      }
    }).catch(() => {});
    return;
  }, [setResult]);
  useEffect(() => {
    const shouldFetch = resolver && propertyName && !isDefaultEmptyPropertyValue(propertyName);
    const atom = shouldFetch ? resolver.byId(propertyName) : makeAtom();
    const currentValue = deref(atom);
    if (isResolved(currentValue)) {
      handleAtomChange(currentValue);
    } else {
      watch(atom, handleAtomChange);
    }
    return () => {
      unwatch(atom, handleAtomChange);
    };
  }, [propertyName, resolver, handleAtomChange]);
  return result;
}